export enum ResponseCode {
  SUCCESS = 'SUCCESS',
  RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND',
  INACTIVE = 'INACTIVE',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  MISSING_REQUIRED_FIELD = 'MISSING_REQUIRED_FIELD',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  DUPLICATE_RECORD = 'DUPLICATE_RECORD',
  EMAIL_SEND_FAILURE = 'EMAIL_SEND_FAILURE',
  PERMISSION_DENIED = 'PERMISSION_DENIED',


  AUTH_INVALID_CREDENTIALS = 'AUTH_INVALID_CREDENTIALS',
  AUTH_PASSWORD_EXPIRED = 'AUTH_PASSWORD_EXPIRED',
  AUTH_PASSWORD_ALREADY_USED = 'AUTH_PASSWORD_ALREADY_USED',
  AUTH_OLD_PASSWORD_INCORRECT = 'AUTH_OLD_PASSWORD_INCORRECT',
  AUTH_EMAIL_NOT_ASSOCIATED = 'AUTH_EMAIL_NOT_ASSOCIATED',
  AUTH_MFA_REQUIRED = 'AUTH_MFA_REQUIRED',
  AUTH_MFA_INVALID_CODE = 'AUTH_MFA_INVALID_CODE',
  AUTH_TOKEN_EXPIRED_OR_INVALID = 'AUTH_TOKEN_EXPIRED_OR_INVALID',
  AUTH_UNAUTHORIZED_ACCESS = 'AUTH_UNAUTHORIZED_ACCESS',

  UNKNOWN_RESPONSE_CODE = 'UNKNOWN_RESPONSE_CODE',
  ACCOUNT_LOCKED = 'ACCOUNT_LOCKED'
}
